
import styled from 'styled-components';

const breakpoints = {
    xxl: 1600,
    xl: 1200,
    lg: 992,
    md: 768,
    sm: 576,
    xs: 0,
};

const getWidth = (span) => {
    if (span === 0) return 'display: none;';
    if (!span) return;
    const width = (span / 24) * 100;
    return `width: ${width}%; max-width: ${width}%;`;
};

const getResponsiveWidth = (props) => {
    const sortedBreakpoints = Object.keys(breakpoints).sort((a, b) => breakpoints[a] - breakpoints[b]);
    let widthCSS = '';
    let lastSetWidth = '';

    sortedBreakpoints.forEach((breakpoint) => {
        if (props[breakpoint] !== undefined) {
            lastSetWidth = getWidth(props[breakpoint]);
        }
        widthCSS += `
        @media (min-width: ${breakpoints[breakpoint]}px) {
          ${lastSetWidth}
        }
      `;
    });
    return widthCSS;
};


const getAlignItems = (align) => {
    switch (align) {
        case 'top':
            return 'flex-start';
        case 'middle':
            return 'center';
        case 'bottom':
            return 'flex-end';
        case 'stretch':
            return 'stretch';
        default:
            return 'flex-start';
    }
};

const getJustifyContent = (justify) => {
    switch (justify) {
        case 'start':
            return 'flex-start';
        case 'end':
            return 'flex-end';
        case 'center':
            return 'center';
        case 'space-around':
            return 'space-around';
        case 'space-between':
            return 'space-between';
        case 'space-evenly':
            return 'space-evenly';
        default:
            return 'flex-start';
    }
};

const getGutterStyle = (gutter) => {
    if (!gutter) return '';
    const [horizontalGutter, verticalGutter] = Array.isArray(gutter) ? gutter : [gutter, 0];
    return `
      row-gap: ${verticalGutter}px;
      > div {
        padding-left: ${horizontalGutter / 2}px;
        padding-right: ${horizontalGutter / 2}px;
      }
    `;
};

export const Row = styled.div.attrs(props => ({
    style: {
        ...props.style,
    },
}))`
scrollbar-width: none;
    display: flex;
    flex-wrap: ${({ Wrap }) => (Wrap === false ? 'nowrap' : 'wrap')};   //wrap 屬性可能是關鍵字，不能用小寫 w，否則會報錯
    align-items: ${({ align }) => getAlignItems(align)};
    justify-content: ${({ justify }) => getJustifyContent(justify)};
    ${({ gutter }) => getGutterStyle(gutter)}
  `;

export const Col = styled.div.attrs(props => ({
    style: {
        flex: '0 0 auto',
        ...props.style,
    },
}))`
  box-sizing: border-box;
  ${({ span }) => getWidth(span)}
  ${props => getResponsiveWidth(props)}
`;


export function RowColDemo() {


    return (
        <>
            <h1 className=' text-5xl my-5'>Demo :  span  = {12}  xs={24} align='middle' justify='center'</h1>
            <Row
                className='h-screen'
                align='middle'
                justify={'center'}
                helper={true} // 輔助線
            >
                <Col
                    xs={24}
                    span={12}
                    className='text-center h-50'
                    helper={true} // 輔助線
                >
                    <Row
                        align='center'
                        justify={'center'}
                        className=' h-full text-5xl'
                    >
                        垂直置中
                    </Row>
                </Col>
            </Row>
            <h1 className=' text-5xl my-5'>Demo :  xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}  </h1>
            <hr />
            <Row
                align='center'
                justify={'space-around'}
                helper={true} // 輔助線
            >
                <Col
                    xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}
                    className='text-center  h-40'
                    helper={true} // 輔助線
                >
                    <Row
                        align='center'
                        justify={'center'}
                        className=' h-full text-xl'
                    >
                        xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}

                    </Row>
                </Col>
                <Col
                    xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}
                    className='text-center h-40'
                    helper={true} // 輔助線
                >
                    <Row
                        align='center'
                        justify={'center'}
                        className=' h-full text-xl'
                    >
                        xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}

                    </Row>
                </Col>
                <Col
                    xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}
                    className='text-center h-40'
                    helper={true} // 輔助線
                >
                    <Row
                        align='center'
                        justify={'center'}
                        className=' h-full text-xl'
                    >
                        Component B

                    </Row>                </Col>
                <Col
                    xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}
                    className='text-center h-40'
                    helper={true} // 輔助線
                >
                    <Row
                        align='center'
                        justify={'center'}
                        className=' h-full text-xl'
                    >
                        Component C

                    </Row>
                </Col>
            </Row>
            <h1 className=' text-5xl my-5'>gutter :  gutter="[24,24]" </h1>
            <hr />
            <Row
                align='middle'
                justify={'center'}
                helper={true} // 輔助線
                gutter={[24, 24]}
            >
                <Col
                    xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}
                    className='text-center  h-40'
                    helper={true} // 輔助線
                >
                    <Row
                        align='center'
                        justify={'center'}
                        className=' h-full text-xl'
                    >
                        xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}

                    </Row>
                </Col>
                <Col
                    xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}
                    className='text-center h-40'
                    helper={true} // 輔助線
                >
                    <Row
                        align='center'
                        justify={'center'}
                        className=' h-full text-xl'
                    >
                        xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}

                    </Row>
                </Col>
                <Col
                    xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}
                    className='text-center h-40'
                    helper={true} // 輔助線
                >
                    <Row
                        align='center'
                        justify={'center'}
                        className=' h-full text-xl'
                    >
                        Component B

                    </Row>                </Col>
                <Col
                    xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}
                    className='text-center h-40'
                    helper={true} // 輔助線
                >
                    <Row
                        align='center'
                        justify={'center'}
                        className=' h-full text-xl'
                    >
                        Component C

                    </Row>
                </Col>
            </Row>
            <hr />
            <Row
                align='middle'
                justify={'center'}
                helper={true} // 輔助線
                gutter={[24, 24]}
            >
                <Col
                    span={8}
                    className='text-center  h-40'
                    helper={true} // 輔助線
                >
                    Component
                </Col>
                <Col
                    span={8}
                    className='text-center  h-40'
                    helper={true} // 輔助線
                >
                    Component
                </Col>
                <Col
                    span={8}
                    className='text-center  h-40'
                    helper={true} // 輔助線
                >
                    Component
                </Col>
                <Col
                    span={8}
                    className='text-center  h-40'
                    helper={true} // 輔助線
                >
                    Component
                </Col>
                <Col
                    span={8}
                    className='text-center  h-40'
                    helper={true} // 輔助線
                >
                    Component
                </Col>
                <Col
                    span={8}
                    className='text-center  h-40'
                    helper={true} // 輔助線
                >
                    Component
                </Col>

            </Row>
        </>
    )

}